import type { RouteRecordRaw } from 'vue-router'

export default function getVoucherCheckoutRoutes(): Array<RouteRecordRaw> {
  const runtime = useRuntimeConfig()
  return [
    {
      name: 'voucher-start',
      path: '/:lang?/voucher/start',
      component: () => import('~/core/pages/checkout/voucher/Start.page.vue'),
      meta: {
        layout: runtime.public.generator.simpleSpasEnabled ? 'simple-checkout' : 'checkout',
      }
    },
    {
      name: 'voucher-buyer',
      path: '/:lang?/voucher/:voucherpurchaseuuid/checkout/buyer',
      component: () => import('~/core/pages/checkout/voucher/Buyer.page.vue'),
      meta: {
        layout: runtime.public.generator.simpleSpasEnabled ? 'simple-checkout' : 'checkout',
      }
    },
    {
      name: 'voucher-payment',
      path: '/:lang?/voucher/:voucherpurchaseuuid/checkout/payment',
      component: () => import('~/core/pages/checkout/voucher/Payment.page.vue'),
      meta: {
        layout: runtime.public.generator.simpleSpasEnabled ? 'simple-checkout' : 'checkout',
      }
    },
    {
      name: 'voucher-redsys-challenge',
      path: '/:lang?/voucher/:voucherpurchaseuuid/redsys/challenge',
      component: () => import('~/core/pages/checkout/voucher/Redsys.Challenge.page.vue'),
      meta: {
        layout: runtime.public.generator.simpleSpasEnabled ? 'simple-checkout' : 'checkout',
      }
    },
    {
      name: 'voucher-confirmation',
      path: '/:lang?/voucher/:voucherpurchaseuuid/confirmation',
      component: () => import('~/core/pages/checkout/voucher/Confirmation.page.vue'),
      meta: {
        layout: runtime.public.generator.simpleSpasEnabled ? 'simple-checkout' : 'thanks',
      }
    },
  ]
}
